import React from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import Header from './Header';
import MainPage from './main';
import TermsOfUse from './TermsOfUse';
import PrivacyPolicy from './PrivacyPolicy';
import ResponsibleTravel from './ResponsibleTravel';
import About from './About';
import AdminLogin from './AdminLogin';
import AdminPanel from './AdminPanel';
import ProtectedRoute from './ProtectedRoute';
import { AuthProvider } from './AuthContext';
import { Routes, Route } from 'react-router-dom';

// The public site header is hidden on the admin pages, which have their own chrome.
const Layout: React.FC = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <>
      {!isAdmin && <Header />}
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/responsible-travel" element={<ResponsibleTravel />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminPanel />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
